import {
  Button,
  IconButton,
  Menu,
  Stack,
  Header
} from '@efast_public/fjd-component-library';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './Header.css';
import { GovosApiRoutes, govosClient } from '../../api/govos-api';
import { Product, ProfileData } from '../../api/user';
import { RouteKey } from 'pages/AppRoutes';
import { useQueryClient } from '@tanstack/react-query';

interface HeaderProps {
  user?: ProfileData;
  products: Product[];
}

export function OdmHeader({ user, products }: HeaderProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isProductsMenuOpen, setIsProductsMenuOpen] = useState(false);
  const userAnchorRef = useRef<HTMLButtonElement>(null);
  const productsAnchorRef = useRef<HTMLButtonElement>(null);

  const handleLogout = async () => {
    govosClient.post(GovosApiRoutes.logout()).then(() => {
      queryClient.setQueryData([GovosApiRoutes.user()], null);
      navigate(RouteKey.LOGIN);
      queryClient.clear();
    });
  };
  const handleHelpClick = () => {
    navigate('/help');
  };

  return (
    <Header
      logo={
        <Stack direction="row" spacing="s">
          {products.length > 0 && (
            <>
              <IconButton
                ref={productsAnchorRef}
                data-testid="products-menu-button"
                data-menu-open={isProductsMenuOpen}
                icon="grid"
                variant="primary-text"
                label="Menu"
                onClick={() => setIsProductsMenuOpen((prev) => !prev)}
              />
              <Menu
                open={isProductsMenuOpen}
                anchorElement={productsAnchorRef}
                placement="bottom-left"
                onClose={() => setIsProductsMenuOpen(false)}
              >
                {products.map((product) => (
                  <Menu.MenuItem
                    key={product.name}
                    label={product.name}
                    icon={`product-${product.identifier}`}
                    onClick={() =>
                      window.open(product.url, '_blank', 'noopener,noreferrer')
                    }
                  />
                ))}
              </Menu>
            </>
          )}
          <Button
            variant="primary-text"
            beforeIcon="product-odm"
            onClick={() => {
              navigate(RouteKey.HOME);
            }}
          >
            Online-Dienst Manager
          </Button>
        </Stack>
      }
      navigation={
        user && (
          <Stack spacing="s" direction="row">
            <Button
              ref={userAnchorRef}
              data-testid="user-button"
              data-menu-open={isUserMenuOpen}
              variant="secondary-outline"
              beforeIcon="user-avatar"
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
            >
              {`${user?.firstname ?? '?'} ${user?.lastname ?? '?'}`}
            </Button>
            <IconButton
              icon={'help-outline'}
              label={'help'}
              variant={'secondary-outline'}
              onClick={handleHelpClick}
            />
            <Menu
              open={isUserMenuOpen}
              anchorElement={userAnchorRef}
              placement="bottom-right"
              onClose={() => setIsUserMenuOpen(false)}
            >
              <Menu.MenuItem
                data-testid="buttonLogout"
                label={'Abmelden'}
                onClick={handleLogout}
              />
            </Menu>
          </Stack>
        )
      }
    />
  );
}
